module.exports = __webpack_public_path__ + "assets/img/landing-mobile-88e8078e.jpg";